import { SideBlock, SidebarRows, StoreLink } from "@softmax/product-ux/catalog";

import type { PreviewContent } from "../content/preview-content.types";
import { LockedRegion } from "../../store-editor";
export function LeaguesBlock({ content }: { content: PreviewContent }) {
  if (content.leagues.length <= 1) return null;

  return (
    <LockedRegion label="Live data, updated automatically">
      <SideBlock
        title="Leagues"
        subtitle={`${content.leagues.length} in ${content.coworldName}`}
      >
        <SidebarRows
          rows={content.leagues.map((league) => ({
            key: league.href,
            left: league.current ? (
              league.name
            ) : (
              <StoreLink href={league.href} tone="row">
                {league.name}
              </StoreLink>
            ),
            right: league.current ? "this page" : null,
          }))}
        />
      </SideBlock>
    </LockedRegion>
  );
}
